// Action example: ?gmf_action=comment:create(product_review,B017382)

import openCommentFormV2 from "@/components/CommentFormV2";
import openPostModal from '@/widgets/PostModal/openPostModal';
import openSocialModal from '@/widgets/SocialFeed/openSocialModal';
import openPopupProfileCard from "@/components/PopupProfileCard/openPopupProfileCard";
import openAvatarConfigurator from '@/components/AvatarConfigurator/openAvatarConfigurator';
import openTokenShop from '@/components/TokenShop/openTokenShop';

const actions = {
    'comment:create'([commentType, targetId], { token, product_score }) {
        openCommentFormV2(commentType, targetId, null, true, { token, product_score });
    },
    'comment:show'([commentId]) {
        openPostModal(commentId);
    },
    'user:show'([merchantCustomerId, tab]) {
        openPopupProfileCard(merchantCustomerId, tab);
    },
    'socialFeed:open'(_args, { board, type }) {
        let filter = null;

        if (board) {
            filter = {
                board_id: board,
            };
        }

        if (type) {
            filter = {
                type: type,
            };
        }

        openSocialModal({
            displayHeader: true,
            filter,
        });
    },
    'avatarConfigurator:open'() {
        openAvatarConfigurator();
    },
    'tokenShop:open'() {
        openTokenShop();
    },
};

export function runQueryActions(search) {
    // parse url query - extract query string from URL if needed
    let queryString = search;
    
    // If it's a full or relative URL (contains ? or /), extract the search part
    if (search.includes('?')) {
        queryString = search.split('?')[1]?.split('#')[0] || '';
    } else if (search.includes('/') || search.includes('#')) {
        // URL without query string
        queryString = '';
    }
    
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('gmf_action');

    if (!query) return false;

    const action = query.split('(').map(s => s.trim())[0];

    const argsUnsplit = query.split('(')[1];

    if (!argsUnsplit) return false;

    const args = argsUnsplit.split(')')[0].split(',').map(arg => arg.trim());
    const namedArgs = {};

    // extract named args
    for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        const [key, value] = arg.split('=');
        if (!value) continue;
        namedArgs[key.trim()] = value.trim();

        // remove named args from args
        args.splice(i--, 1);
    }

    if (!actions[action]) {
        console.error('Unknown action', action);
        return false;
    }

    actions[action](args, namedArgs);
    return true;
}
